//App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import KanbanBoard from './components/KanbanBoard';
import { bootstrapChatwootContext, requestAppContext } from './chatwootContext';

bootstrapChatwootContext();

export default function App() {
  useEffect(() => {
    requestAppContext();
  }, []);

  return (
    <Router basename={process.env.PUBLIC_URL || '/'}>
      <div className="app-container">
        <main>
          <Routes>
            <Route path="/" element={<KanbanBoard />} />
            {/* Futuras rotas podem ser adicionadas aqui */}
          </Routes>
        </main>
      </div>
    </Router>
  );
}
